import { render, staticRenderFns } from "./financial-detail.vue?vue&type=template&id=64c3f146&scoped=true"
import script from "./financial-detail.vue?vue&type=script&lang=js"
export * from "./financial-detail.vue?vue&type=script&lang=js"
import style0 from "./financial-detail.vue?vue&type=style&index=0&id=64c3f146&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c3f146",
  null
  
)

export default component.exports